angular
  .module('contrast.services.passwordmeter', [])
  .factory('PasswordMeterService', function () {
    return {
      initialize: function (scope) {
        scope.passwordPolicyLoaded = false
        scope.score = 0
        scope.size = 0
        scope.upper = 0
        scope.lower = 0
        scope.numeric = 0
        scope.symbol = 0
        scope.sizeStatus = false
        scope.upperStatus = false
        scope.lowerStatus = false
        scope.numericStatus = false
        scope.symbolStatus = false
      },

      setRestrictions: function (passwordPolicy, scope) {
        scope.minSize = passwordPolicy ? passwordPolicy.min_length : 0
        scope.minUpper = passwordPolicy ? passwordPolicy.min_upper : 0
        scope.minLower = passwordPolicy ? passwordPolicy.min_lower : 0
        scope.minNumeric = passwordPolicy ? passwordPolicy.min_numbers : 0
        scope.minSymbol = passwordPolicy ? passwordPolicy.min_symbols : 0
        scope.passwordPolicyLoaded = true
      },

      getType: function (score) {
        var type = 'success'
        if (score <= 40) {
          type = 'danger'
        } else if (score <= 60) {
          type = 'warning'
        } else if (score <= 80) {
          type = 'info'
        } else {
          type = 'success'
        }
        return type
      },

      checkPassword: function (scope, value) {
        var self = this
        if (scope.passwordPolicyLoaded) {
          scope.size = value.length
          scope.upper = self.hasUpper(value)
          scope.lower = self.hasLower(value)
          scope.numeric = self.hasNumber(value)
          scope.symbol = self.hasSymbol(value)

          scope.score = 0
          scope.sizeStatus = self.validComponent(scope.minSize, scope.size)
          if (scope.sizeStatus) {
            scope.score += 20
          }

          scope.upperStatus = self.validComponent(scope.minUpper, scope.upper)
          if (scope.upperStatus) {
            scope.score += 20
          }

          scope.lowerStatus = self.validComponent(scope.minLower, scope.lower)
          if (scope.lowerStatus) {
            scope.score += 20
          }

          scope.numericStatus = self.validComponent(
            scope.minNumeric,
            scope.numeric
          )
          if (scope.numericStatus) {
            scope.score += 20
          }

          scope.symbolStatus = self.validComponent(
            scope.minSymbol,
            scope.symbol
          )
          if (scope.symbolStatus) {
            scope.score += 20
          }

          scope.valid = self.validPassword(scope)
        }
      },

      reset: function (scope) {
        scope.score = 0
        scope.size = 0
        scope.upper = 0
        scope.lower = 0
        scope.numeric = 0
        scope.symbol = 0
        scope.sizeStatus = false
        scope.upperStatus = false
        scope.lowerStatus = false
        scope.numericStatus = false
        scope.symbolStatus = false
      },

      validPassword: function (scope) {
        return (
          scope.sizeStatus &&
          scope.upperStatus &&
          scope.lowerStatus &&
          scope.numericStatus &&
          scope.symbolStatus
        )
      },

      validComponent: function (min, current) {
        return min <= current
      },

      isLetterCode: function (c) {
        return (c >= 65 && c <= 90) || (c >= 97 && c <= 122)
      },

      isNumberCode: function (c) {
        return c >= 49 && c <= 57
      },

      hasUpper: function (s) {
        var self = this
        var counter = 0
        for (var i = 0; i < s.length; i++) {
          var c = s.charAt(i)
          if (self.isLetterCode(s.charCodeAt(i)) && c.toUpperCase() == c) {
            counter++
          }
        }

        return counter
      },

      hasLower: function (s) {
        var self = this
        var counter = 0
        for (var i = 0; i < s.length; i++) {
          var c = s.charAt(i)
          if (self.isLetterCode(s.charCodeAt(i)) && c.toLowerCase() == c) {
            counter++
          }
        }
        return counter
      },

      hasNumber: function (s) {
        var counter = 0
        for (var i = 0; i < s.length; i++) {
          var c = s.charAt(i)
          if (!isNaN(c)) {
            counter++
          }
        }
        return counter
      },

      hasSymbol: function (s) {
        var counter = 0
        for (var i = 0; i < s.length; i++) {
          var c = s.charAt(i)
          var rgx = /[\W_]+/
          if (rgx.test(c)) {
            counter++
          }
        }
        return counter
      }
    }
  })
